var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsBodylineOff = function SvgPartsBodylineOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.333 27.238a.57.57 0 0 1-.571-.571v-.559c0-2.388.669-4.7 1.988-6.874 2.04-3.363 2.378-7.156.947-10.682l-1.22-3.004a.572.572 0 0 1 1.06-.43l1.219 3.005c1.57 3.869 1.204 8.025-1.03 11.705-1.208 1.99-1.821 4.104-1.821 6.28v.559a.57.57 0 0 1-.572.571M26.667 27.238a.57.57 0 0 1-.572-.571v-.559c0-2.176-.613-4.29-1.822-6.28-2.233-3.68-2.598-7.836-1.029-11.705l1.22-3.005a.571.571 0 1 1 1.058.43l-1.219 3.004c-1.43 3.526-1.094 7.32.947 10.682 1.32 2.173 1.988 4.486 1.988 6.874v.559a.57.57 0 0 1-.571.571M16 17.905a.38.38 0 0 1-.381-.381V16a.381.381 0 0 1 .762 0v1.524c0 .21-.17.38-.381.38"
  }))));
};
export default SvgPartsBodylineOff;